
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const SectionWrapper = ({
   children,
   isActive,
   isPreview,
   onClickSection,
   activeEditableSection,
   id,
   // slug,
}) => {
   if(!isPreview){
      return (
         <>{children}</>
      )
   }
   return (
      <div
         id={ id }
         onClick={ () => {
            if(onClickSection && !isActive){
               onClickSection()
            }
         } }
         role='presentation'
         className={ cx({
            'flex w-full cursor-pointer relative': true,
            'border-[3px] border-action z-[20]': isActive,
            'z-16': !isActive,
         }) }
      >
         {
            !isActive && activeEditableSection && (
               <div
                  className='bg-[#FAFBFC4D] absolute top-0 left-0 z-[16] w-full h-full'
                  style={ {
                     pointerEvents: 'painted',
                     backdropFilter: 'blur(8px)',
                  } }
               >
               </div>
            )
         }
         {children}
      </div>

   );
}
SectionWrapper.propTypes = {
   children: PropTypes.any,
   isActive: PropTypes.bool,
   isPreview: PropTypes.bool,
   onClickSection: PropTypes.func,
   id: PropTypes.string,
   activeEditableSection: PropTypes.any,
};
SectionWrapper.defaultProps = {
}
export default SectionWrapper;


